import { $totype } from "foundation-ts/commons";
import { Resp, RespType, TSRequest, Verb } from "foundation-ts/tsrequest";
import { Nullable, url } from "foundation-ts/types";

import { config } from "@/config/config";

export interface Address {
    firstName?: string;
    lastName?: string;
    street: string;
    city: string;
    region?: string;
    country: string;
    zipCode: string;
}

export interface Customer {
    firstName?: string;
    lastName?: string;
    email?: string;
    phoneNumber?: string;
    username?: string;
    birthdate?: string;
    accountIdentifier?: string;
    billingAddress?: Address;
    shippingAddress?: Address;
}

export interface Amount {
    value: number;
    currency: string;
}

// OrderLine
export interface OrderLine {
    ITN: string,            // Item number
    QTY: number,            // Quantity
    UPR: number,            // Unit price
    NET: number,            // Net amount
    TAX: number,            // Tax amount
    GRS: number,            // Gross amount
    DSC?: string,           // Description
    TXC?: string,           // Tax class
    TXP?: number,           // Tax percentage
}

// Order
export interface Order {
    orderId: string;
    amount: Amount;
    orderLines?: OrderLine[];
    customer?: Customer;
    recipient?: Customer;
    transactionInfo?: Record<string, string>;
}

export type SESSION_STATUS = 'Created' | 'Completed' | 'Expired' | 'Canceled' | 'RetryCountExceeded' | 'Error' | 'MerchantNotActive' | 'Pending' | 'Declined' | 'SoftDeclined' | 'HardDeclined' | 'UserInteractionDone';
export type PAYMENT_METHOD = 'AMEX' | 'AURORE' | 'CARTEBLEUE' | 'COD' | 'DINERS' | 'DIRDEBIT' | 'EFT' | 'ELECTRON' | 'INVOICE' | 'JCB' | 'KLARNAINV' | 'KLARNAACCT' | 'KLARNACAMP' | 'KLARNAPART' | 'MAESTRO' | 'MASTERCARD' | 'PAYPAL' | 'SOFORT' | 'VISA';

export interface CreatePaymentResponse {
    sessionURL: url,
    sessionID: string,
    returnCode: number
}

export interface PaymentStatusResponse {
    sessionID: string,
    status: SESSION_STATUS
    paymentMethod?: Nullable<PAYMENT_METHOD>,
    returnCode?: Nullable<number>
}

export async function initiatePayment(orders: OrderLine[]): Promise<Nullable<CreatePaymentResponse>> {
    const body = { items: orders };

    const req = new TSRequest(config.app.apiPath);
    const [resp, status] = await req.request('/tools/payment-session', Verb.Post, RespType.Json, [Resp.Created], body, { 'Content-Type': 'application/json' });
    return status === Resp.Created ? $totype<CreatePaymentResponse>(resp) : null;
}

export async function getPaymentStatus(sessionID: string): Promise<Nullable<PaymentStatusResponse>> {
    const req = new TSRequest(config.app.apiPath);
    const [resp, status] = await req.request(`/tools/payment-session/${sessionID}`, Verb.Get, RespType.Json, [Resp.OK]);
    console.log(resp);
    console.log(status);
    return $totype<PaymentStatusResponse>(resp);
}